import { render } from "./card-image.vue?vue&type=template&id=585e6e90"
import script from "./card-image.vue?vue&type=script&lang=ts"
export * from "./card-image.vue?vue&type=script&lang=ts"
script.render = render

export default script